import { education, services, comission, settings, more, reference } from './svg/menuSVG'
import { img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12 } from './images/main'
import { main, adresses, priveleges, parents, admission, medicine, education as educ, documents, candidateInfo, more as moree, qualification, award, punish, experience, lesson, event, role, attestation, history, curator, list } from './svg/modalSVG'

export const version = '15.07.3'

// Если REACT_APP_URL не задан (локальное разворачивание школой вместе с бэкендом
// на одном хосте), запросы автоматически идут на origin, с которого отдан фронт.
export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL || `${window.location.origin}/api`
export const BACKEND_URL_ORIGIN = process.env.REACT_APP_URL
    ? process.env.REACT_APP_URL.replace(/\/api$/, '')
    : window.location.origin
export const BACKEND_DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN
export const DNEVNIK2_URL = (process.env.REACT_APP_DNEVNIK2_URL || 'https://journal2.edumil.ru').replace(/\/$/, '')

export const IS_JOURNAL_MODE = window.location.hostname === 'journal2.edumil.ru'
export const API_BASE_URL = IS_JOURNAL_MODE ? `${DNEVNIK2_URL}/proxy/api` : BACKEND_URL_PREFIX
export const SITE_ORIGIN = IS_JOURNAL_MODE ? DNEVNIK2_URL : BACKEND_URL_ORIGIN
export const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL

export const itemsOnPage = 15

export const menuItems = [
    {
        label: 'Образование',
        link: '/education',
        icon: education,
        id: 1,
        menu: [{
            label: 'Основное образование',
            link: '/education',
            id: 11,
            menu: [{ label: 'Настройки расписания', link: '/schedule_settings' },
            { label: 'Варианты расписания', link: '/schedule_variants' },
            { label: 'Составление расписания', link: '/scheduling' },
            { label: 'Расписание', link: '/schedule' },
            { label: 'Классный журнал', link: '/classbook' },
            { label: 'Домашние задания', link: '/homeworks' },
            { label: 'Тематическое планирование', link: '/thematic_planning' },
            { label: 'Структура учебного предмета', link: '/discipline_structure_ba' },
            { label: 'Электронная зачетка', link: '/digital_exam_book' },
            { label: 'Контроль ведения классного журнала', link: '/journal_control' },
            { label: 'Учебный план', link: '/study_plans' },
            { label: 'Предметы', link: '/courses' },
            { label: 'Предметы по годам обучения', link: '/subjects_by_year_study' },
            { label: 'Классы', link: '/classing' },
            { label: 'Подгруппы', link: '/subgroups' },
            { label: 'Критерии воспитанности', link: '/manners' },
            { label: 'Журнал воспитанности', link: '/journal_manners' },
            {
                label: 'ОГЭ', link: '/', id: 111,
                menu: [
                    { label: 'Информация о ОГЭ', link: '/oge/info', id: 1111 },
                    { label: 'Расписание ОГЭ', link: '/oge/schedule', id: 1112 },
                    { label: 'Результаты ОГЭ', link: '/oge/report', id: 1113 },
                ]
            },
            {
                label: 'ЕГЭ', link: '/', id: 112,
                menu: [
                    { label: 'Информация о ЕГЭ', link: '/ege/info', id: 1121 },
                    { label: 'Расписание ЕГЭ', link: '/ege/schedule', id: 1122 },
                    { label: 'Результаты ЕГЭ', link: '/ege/report', id: 1123 },
                ]
            },
            { label: 'Профили обучения', link: '/track_profile' },
            { label: 'Учебные смены', link: '/study_shifts' },
            { label: 'Образовательные направления', link: '/edu_directions' },
            { label: 'Культура', link: '/culture' },
            { label: 'Компетентность', link: '/competence' },
            {
                label: 'Методическая работа', link: '/', id: 113,
                menu: [
                    { label: 'Учебно-методические комплекты', link: '/educational_methodological_kits', id: 1131 },
                    { label: 'Методические объединения', link: '/methodological_association', id: 1132 },
                    { label: 'Уровни методических объединений', link: '/levels_methodological_associations', id: 1133 },
                ]
            },
            { label: 'Открытый урок', link: '/' },
            { label: 'Тестовые задания', link: '/' },
            { label: 'Электронная ручка - журналы', link: '/' },
            ]
        },
        {
            label: 'Дополнительное образование',
            link: '/education',
            id: 12,
            menu: [{ label: 'Настройки расписания ДО', link: '/schedule_settings_do' },
            { label: 'Варианты расписания ДО', link: '/do_schedule_variants' },
            { label: 'Составление расписания ДО', link: '/scheduling_do' },
            { label: 'Личное расписание ДО', link: '/personal_schedule_do' },
            { label: 'Журнал ДО', link: '/classbook_do' },
            { label: 'Тематическое планирование ДО', link: '/thematic_planning_do' },
            { label: 'Структура учебного предмета ДО', link: '/discipline_structure_do' },
            { label: 'Контроль ведения  журнала ДО', link: '/journal_control_do' },
            { label: 'Учебный план ДО', link: '/study_plans_do' },
            { label: 'Предметы ДО', link: '/subjects_extra_edu' },
            { label: 'Группы ДО', link: '/groups_do' },
            ]
        },
        {
            label: 'Внеурочная деятельность',
            link: '/education',
            id: 13,
            menu: [{ label: 'Настройки расписания ВД', link: '/schedule_settings_vd' },
            { label: 'Варианты расписания ВД', link: '/vd_schedule_variants' },
            { label: 'Составление расписания ВД', link: '/scheduling_vd' },
            { label: 'Журнал ВД', link: '/classbook_vd' },
            { label: 'Тематическое планирование ВД', link: '/thematic_planning_vd' },
            { label: 'Структура учебного предмета ВД', link: '/discipline_structure_vd' },
            { label: 'Контроль ведения  журнала ВД', link: '/journal_control_vd' },
            { label: 'Учебный план ВД', link: '/study_plans_vd' },
            { label: 'Предметы ВД', link: '/subjects_extracur_edu' },
            { label: 'Группы ВД', link: '/groups_vd' },
            ]
        }
        ]
    },
    {
        label: 'Информационные сервисы',
        link: '/education',
        icon: services,
        id: 2,
        menu: [{
            label: 'Мероприятия',
            link: '/education',
            id: 21,
            menu: [{ label: 'Список мероприятий', link: '/events_list' },
            { label: 'Уровни мероприятий', link: '/event_levels' },
            { label: 'Направления воспитательной работы', link: '/educ_directions' },
            { label: 'Формы мероприятий', link: '/act_types' },
            { label: 'Типы событий', link: '/event_types' },
            { label: 'Виды достижений', link: '/achievements' },
            { label: 'Баллы за достижения', link: '/achiev_points' },
            ]
        },
        {
            label: 'Медпункт',
            link: '/education',
            id: 24,
            menu: [{ label: 'Медкарты', link: '/medical_cards' },
            { label: 'Освобождения', link: '/discharge' },
            { label: 'Виды болезней', link: '/types_of_disease' },
            { label: 'Виды прививок', link: '/types_of_vaccinations' },
            { label: 'МКБ-10', link: '/MKB_ten' },
            { label: 'Группы здоровья', link: '/health_group' },
            { label: 'Физкультурные группы', link: '/physical_group' },
            { label: 'Специальные медицинские группы', link: '/special_medical_groups' },
            ]
        },
        {
            label: 'Информационный паспорт',
            link: '/education',
            id: 27,
            menu: [{ label: 'Генеральный план зданий', link: '/' },
            { label: 'Схема ЛВС', link: '/' },
            { label: 'Перечень используемого ПО', link: '/' },
            { label: 'Скорость интернета', link: '/' },
            { label: 'Скорость обработки запросов LMS', link: '/' },
            { label: 'Документы', link: '/' },
            ]
        },
        { label: 'Объявления', link: '/ads' },
        { label: 'Вопрос-Ответ', link: '/faq' },
        { label: 'Публикации, статьи, пособия', link: '/publication' },
        { label: 'Полезные сайты', link: '/useful_sites' },
        {
            label: 'Столовая',
            link: '/education',
            id: 22,
            menu: [{ label: 'Меню на день', link: '/menu_day' },
            { label: 'Блюда', link: '/dishes' },
            { label: 'Группы питания', link: '/group_nutrition' },
            { label: 'Периоды питания', link: '/period_nutrition' },
            { label: 'Сотрудники столовой', link: '/canteen_staff' },
            ]
        },
        { label: 'Обмен файлами', link: '/' },
        { label: 'Мониторинг учебной деятельности', link: '/' },
        {
            label: 'Личные дела',
            link: '/education',
            id: 23,
            menu: [{ label: 'Учащиеся', link: '/students' },
            { label: 'Кадровый состав', link: '/personnel' },
            { label: 'Активности', link: '/activity' },
            { label: 'Профориентация', link: '/profotbor' },
            ]
        },
        {
            label: 'Учебно-материальная база',
            link: '/education',
            id: 25,
            menu: [{ label: 'Объекты УМБ', link: '/directoryObjectsUMB' },
            { label: 'Кабинеты', link: '/rooms' },
            { label: 'Типы кабинетов', link: '/room_types' },
            { label: 'Оборудование и ТМЦ', link: '/equipment' },
            { label: 'Группы оборудования', link: '/equipment_groups' },
            ]
        },
        {
            label: 'Телестудия',
            link: '/education',
            id: 26,
            menu: [{ label: 'Типы программ', link: '/tv_program_type' },
            { label: 'Расписание программ', link: '/tv_program_schedule' },
            ]
        },
        { label: 'Родительские собрания', link: '/parent_meetings' },
        ]
    },
    {
        label: 'Приемная комиссия',
        link: '/education',
        icon: comission,
        id: 3,
        menu: [
            { label: 'Претенденты', link: '/applicant' },
            { label: 'Экзаменационные группы', link: '/applicant_group' },
            { label: 'Приемные комиссии', link: '/admissions' },
            { label: 'Вопросы для тестирования', link: '/enroll_questions' },
            { label: 'Предметные комиссии', link: '/exam_board' },
            { label: 'Города сдачи вступительных испытаний', link: '/exam_city' },
            { label: 'Направления для поступления', link: '/trajectories' },
            { label: 'Временные слоты', link: '/time_slot' },
            { label: 'Расписание тестирования', link: '/testing_schedule' },
            { label: 'Варианты экзаменационных заданий', link: '/applicant_question_set' },
        ],
    },
    {
        label: 'Настройки',
        link: '/education',
        icon: settings,
        id: 4,
        menu: [
            { label: 'Общие настройки', link: '/settings' },
            { label: 'Локальные настройки', link: '/' },
            { label: 'Учебная структура', link: '/educational_structure' },
            { label: 'Учебные статусы', link: '/educational_statuses' },
            { label: 'Варианты оценок', link: '/grades_options' },
            { label: 'Веса оценок', link: '/grade_weight' },
            { label: 'Типы учебных занятий', link: '/types_study_sessions' },
            { label: 'Учебные года', link: '/school_years' },
            { label: 'Учебные периоды', link: '/terms' },
            { label: 'Недели', link: '/school_weeks' },
            { label: 'Праздничные дни', link: '/holidays' },
            { label: 'Новый учебный год', link: '/new_school_year' },
            { label: 'Пользовательский словарь', link: '/user_dictionary' },
            { label: 'Формы обучения', link: '/forms_of_education' },
            { label: 'Ступени обучения', link: '/stages_study' },
            { label: 'Показатели физической подготовки', link: '/fitness_indicators' },
            { label: 'Страны', link: '/countries' },
            { label: 'Учебные заведения', link: '/educational_institutions' },
            { label: 'Учебный распорядок', link: '/periods' },
            { label: 'Распорядок дня', link: '/daily_routine' },
            { label: 'Типовые комментарии к оценкам', link: '/typical_comment' },
            { label: 'Закрытие учебного года', link: '/' },
            { label: 'Роли', link: '/roles' },
            { label: 'Настройка прав доступа', link: '/setting_access_rights' },
            { label: 'Настройка журнализации', link: '/setting_logging' },
            { label: 'Журнал изменений', link: '/' },
            { label: 'Журнал безопасности', link: '/security_log' },
            { label: 'Журнал входов', link: '/login_register' },
            { label: 'Описание таблиц', link: '/table_description' },
            { label: 'Резервное копирование', link: '/backup' },
            { label: 'Шаблоны отчетов', link: '/' },
            { label: 'Группы отчетов', link: '/report_groups' },
            { label: 'Сервисные сообщения', link: '/' },
            { label: 'Видеокамеры', link: '/video_config' },
            { label: 'Видеоуроки (архив)', link: '/video_records' },
        ]
    },
    {
        label: 'Дополнительно',
        link: '/education',
        icon: more,
        id: 5,
        menu: [
            { label: 'Структурные подразделения', link: '/structural_divisions' },
            { label: 'Импорт данных', link: '/initial_import' },
            { label: 'Импорт фотографий', link: '/importing_photos' },
            { label: 'Приказы', link: '/orders' },
            { label: 'Журнал документов', link: '/documents_journal' },
            { label: 'Виды документов', link: '/types_documents' },
            { label: 'Подключенные пользователи', link: '/' },
            { label: 'Выгрузка в "Интеграция-СВО"', link: '/unloading_integration_SVO' },
        ]
    },
    {
        label: 'Справка',
        link: '/education',
        icon: reference,
        id: 6,
        menu: [
            { label: 'Содержание', link: '/' },
            { label: 'Новое в версии', link: '/' },
            { label: 'Руководство оператора', link: '/' },
            { label: 'Руководство администратора', link: '/' },
            { label: 'О программе', link: '/', type: 'button' },
        ]
    },
    {
        label: 'Методический кабинет',
        link: '/methodOffice',
        icon: settings,
        id: 7,
        menu: [
            { label: 'Кабинет', link: '/methodOffice' },
            { label: 'Новое в версии', link: '/' },
            { label: 'Руководство оператора', link: '/' },
            { label: 'Руководство администратора', link: '/' },


        ]
    }
]

export const cardItems = [
    { color1: '#6B4EFF', color2: '#757AFF', title: 'Расписание', icon: img1, link: '/schedule' },
    { color1: '#20748C', color2: '#0DBFAF', title: 'Классный журнал', icon: img2, link: '/classbook' },
    { color1: '#41C876', color2: '#48CE7E', title: 'Личные дела', icon: img3, link: '/students' },
    { color1: '#61A024', color2: '#A6D429', title: 'Мероприятия', icon: img4, link: '/events_list' },
    { color1: '#9844FF', color2: '#E47DBB', title: 'Вопрос-ответ', icon: img5, link: '/faq' },
    { color1: '#3D52DA', color2: '#5B82E1', title: 'Объявления', icon: img6, link: '/ads' },
    { color1: '#F2821B', color2: '#FBBA57', title: 'Открытый урок', icon: img7, link: '/' },
    { color1: '#1E8572', color2: '#0CBD93', title: 'Методический кабинет', icon: img8, link: '/methodOffice' },
    { color1: '#B6CD28', color2: '#B2CE09', title: 'Тематическое планирование', icon: img9, link: '/thematic_planning' },
    { color1: '#06A98C', color2: '#2ED8AF', title: 'Отчетность', icon: img10, link: '/reports' },
    { color1: '#DF54C0', color2: '#FB7EEE', title: 'Электронные документы', icon: img11, link: '/' },
    { color1: '#1E6085', color2: '#0C9DBD', title: 'Электронное тестирование', icon: img12, link: '/' }
]

export const accessStatuses = ['Полный', 'Чтение', 'Нет']

export const candidatesModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Адреса', value: 'adresses', icon: adresses },
    { name: 'Льготы', value: 'priveleges', icon: priveleges },
    { name: 'Родители', value: 'parents', icon: parents },
    { name: 'Поступление', value: 'admission', icon: admission },
    { name: 'Медицина', value: 'medicine', icon: medicine },
    { name: 'Доп. образование', value: 'education', icon: educ },
    { name: 'Информация о кандидате', value: 'candidateInfo', icon: candidateInfo },
    { name: 'Расписание тестирования', value: 'schedule', icon: event },
]
export const medCardsModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Состав семьи', value: 'family', icon: adresses },
    { name: 'Обращения', value: 'appeals', icon: priveleges },
    { name: 'Прививки и медотводы', value: 'vaccinations', icon: parents },
    { name: 'Антропометрия', value: 'anthropometry', icon: admission },
    { name: 'Записи специалиста', value: 'specNotes', icon: medicine },

]
export const EventsListModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Участники', value: 'participants', icon: parents },
    { name: 'Ответственные', value: 'responsible', icon: priveleges },
    { name: 'Участники-сотрудники', value: 'members_employees', icon: parents },
    { name: 'Параметры', value: 'parameters', icon: admission },

]

export const personnelModalModes = [
    { name: 'Главная', value: 'main', apiTab: 'main', type: 'dict', icon: main },
    { name: 'Дополнительно', value: 'additional', apiTab: 'additional', type: 'dict', icon: moree },
    { name: 'Образование', value: 'education', apiTab: 'education', type: 'array', icon: admission },
    { name: 'Повышение квалификации', value: 'qualification', apiTab: 'professional_development', type: 'array', icon: qualification },
    { name: 'Награды', value: 'award', apiTab: 'awards', type: 'array', icon: award },
    { name: 'Взыскания', value: 'punish', apiTab: 'penalties', type: 'array', icon: punish },
    { name: 'Общий стаж', value: 'experience', apiTab: 'total_work_experience', type: 'composite', icon: experience },
    { name: 'Предметы', value: 'lesson', apiTab: 'courses', type: 'special', icon: lesson },
    { name: 'Мероприятия', value: 'event', apiTab: 'events', type: 'array', icon: event },
    { name: 'Роли', value: 'role', apiTab: 'roles', type: 'special', icon: role },
    { name: 'Документы', value: 'documents', apiTab: 'files', type: 'special', icon: documents },
    { name: 'Аттестация', value: 'attestation', apiTab: 'certification', type: 'array', icon: attestation },
    { name: 'Состав семьи', value: 'family', apiTab: 'family', type: 'array', icon: parents },
    { name: 'Отпуск', value: 'vacation', apiTab: 'vacation', type: 'array', icon: experience },
    { name: 'Социальные льготы', value: 'socialBenefits', apiTab: 'privileges', type: 'array', icon: priveleges },
    { name: 'Сведения о воинском учете', value: 'militaryRecord', apiTab: 'military', type: 'dict', icon: documents },
    { name: 'Иностранные языки', value: 'languages', apiTab: 'foreign_languages', type: 'array', icon: lesson },
    { name: 'Выданные документы', value: 'issuedDocuments', apiTab: 'issued_documents', type: 'array', icon: documents },
    { name: 'Сведения об УМБ', value: 'umbInfo', apiTab: 'equipment', type: 'composite', icon: documents },
]
//
export const variableStuffModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Поступление', value: 'admission', icon: moree },
    { name: 'Обучение', value: 'training', icon: admission },
    { name: 'Профотбор', value: 'profotbor', icon: admission },
    { name: 'ИОТ', value: 'iot', icon: admission },
    { name: 'Антропометрия', value: 'anthropometry', icon: award },
    { name: 'Учебные универсальные действия', value: 'severity', icon: punish },
    { name: 'Записки специалистов', value: 'specialist_records', icon: punish },
    { name: 'Итоговые оценки', value: 'grades', icon: punish },
    { name: 'Данные по ЕГЭ и ОГЭ', value: 'exams', icon: punish },
    { name: 'Состав семьи', value: 'family', icon: punish },
    { name: 'Льготы', value: 'privileges', icon: punish },
    { name: 'Доверенные лица', value: 'trusted_persons', icon: punish },
    { name: 'Поощрения и наказания', value: 'penalties', icon: punish },
    { name: 'Мероприятия', value: 'events', icon: lesson },
    { name: 'Общественная нагрузка', value: 'public_load', icon: lesson },
    { name: 'Документы', value: 'documents', icon: documents },
    { name: 'Портфолио', value: 'portfolio', icon: lesson },
    { name: 'Выданные документы', value: 'issued_documents', icon: documents },
    { name: 'Физ.подготовка', value: 'physical_training', icon: experience },
    { name: 'Характеристика', value: 'characteristic', icon: event },
    { name: 'Достижения', value: 'achievements', icon: event },
    { name: 'Увлечения', value: 'hobby', icon: role },
    { name: 'Здоровье', value: 'health', icon: event },

]

export const classingModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Состав', value: 'team', icon: parents },
    { name: 'История', value: 'history', icon: history },
    { name: 'Кураторы', value: 'curator', icon: curator }
]

export const applicantGroupModalModes = [
    { name: 'Обшие', value: 'general', icon: main, error: false },
    { name: 'Расписание экзаментов', value: 'exam_schedule', icon: history, error: false },
    { name: 'Нормативы ОФП', value: 'physical_standards', icon: award, error: false },
    { name: 'Состав', value: 'compound', icon: list, error: false },
]

export const groupsDoVdModalModes = [
    { name: 'Главная', value: 'main', icon: main, error: false },
    { name: 'Состав', value: 'structure', icon: list, error: false },
    { name: 'Тип уч. периода', value: 'term_types', icon: history, error: false },
]

export const coursesModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Файлы', value: 'files', icon: parents },
]

export const defaultModalModes = [
    { name: 'Главная', value: 'main', icon: main },
]

export const planningModalModes = [
    { name: 'Основная часть', value: 'planning', icon: main },
    { name: 'Домашнее задание', value: 'homework', icon: admission },
    { name: 'Файлы', value: 'files', icon: documents },
    { name: 'Пояснительная записка', value: 'about', icon: moree },
    { name: 'Список литературы', value: 'literature', icon: lesson },
]

export const planningModalModesDO_VD = [
    { name: 'Основная часть', value: 'planning', icon: main },
    { name: 'Домашнее задание', value: 'homework', icon: admission },
    { name: 'Файлы', value: 'files', icon: documents },
]

export const educationalStructureModalModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Основное образование', value: 'basicEducation', icon: adresses },
    { name: 'Доп. образование', value: 'additionalEducation', icon: priveleges },
    { name: 'Внеурочная деятельность', value: 'extracurricularActivities', icon: parents },
    { name: 'Элективы', value: 'electives', icon: admission },
    // {name: 'Медицина', value: 'medicine', icon: medicine},
    // {name: 'Доп. образование', value: 'education', icon: educ},
    // {name: 'Документы', value: 'documents', icon: documents},
    // {name: 'Информация о кандидате', value: 'candidateInfo', icon: candidateInfo},
]

export const studyPlansModes = [
    { name: 'Главная', value: 'main', icon: main },
    { name: 'Состав', value: 'settings', icon: admission },
]

export const armyClasses = [
    { name: 'Мотострелковые войска', value: 1 },
    { name: 'Танковые войска', value: 1 },
    { name: 'Ракетные войска и артиллерия', value: 1 },
    { name: 'Войска противовоздушной обороны', value: 1 },
    { name: 'Разведывательные соединения и воинские части', value: 1 },
    { name: 'Инженерные войска', value: 1 },
    { name: 'Войска связи', value: 1 }
]

export const methodOffice = [
    { name: 'Общие', value: 'main', icon: main },
    { name: 'Допуск', value: 'access', icon: admission },
]

export const armyDistricts = [
    { name: 'Отсутствует', value: '' },
    { name: 'Западный военный округ', value: 'Западный военный округ' },
    { name: 'Восточный военный округ', value: 'Восточный военный округ' },
    { name: 'Центральный военный округ', value: 'Центральный военный округ' },
    { name: 'Южный военный округ', value: 'Южный военный округ' },
    { name: 'Северный флот', value: 'Северный флот' }
]

export const enrollmentResults = [
    { name: '', value: '' },
    { name: 'зачислен', value: 'зачислен' },
    { name: 'не зачислен', value: 'не зачислен' },
    { name: 'резерв', value: 'резерв' }
]

export const examAdmissionStatuses = [
    { name: '', value: '' },
    { name: 'допущен', value: 'допущен' },
    { name: 'не допущен', value: 'не допущен' }
]

export const statuses = [
    { name: 'Статус1', value: "current" },
    { name: 'Статус2', value: 1 },
    { name: 'Статус3', value: 1 },
    { name: 'Статус4', value: 1 }
]
export const statusesForStudents = [
    { name: 'Все', value: 'all' },
    { name: 'Текущие', value: "current" },
    { name: 'Учащийся этого года', value: 'this_year' },
    { name: 'Отчислены', value: 'expelled' },
    { name: 'Выпускники', value: 'graduated' },
    { name: 'Академический отпуск', value: 'academic_leave' },
]

export const socialstatus = [
    { name: "Из других семей", value: 1 },
    { name: 'Статус2', value: 1 },
    { name: 'Статус3', value: 1 },
    { name: 'Статус4', value: 1 }
]

export const cities = [
    { name: 'Санкт-Петербург', value: 1 },
    { name: 'Москва', value: 1 },
    { name: 'Брянск', value: 1 }
]

export const streams = [
    { name: 'Основной набор', value: 0 },
    { name: 'Донабор', value: 1 }
]

export const sportGrade = [
    { name: '5' },
    { name: '4' },
    { name: '3' },
    { name: 'зачет' }
]

export const sex = [
    { name: 'мужской' },
    { name: 'женский' }
]

export const docTypes = [
    { name: 'Паспорт' },
    { name: 'Св. о рождении' }
]

export const weekForSchedule = [
    { name: 'Понедельник', value: 0 },
    { name: 'Вторник', value: 1 },
    { name: 'Среда', value: 2 },
    { name: 'Четверг', value: 3 },
    { name: 'Пятница', value: 4 },
    { name: 'Суббота', value: 5 },
    { name: 'Воскресенье', value: 6 },
]

export const PARALLELS = [
    { name: "1", value: '1' },
    { name: "2", value: '2' },
    { name: "3", value: '3' },
    { name: "4", value: '4' },
    { name: "5", value: '5' },
    { name: "6", value: '6' },
    { name: "7", value: '7' },
    { name: "8", value: '8' },
    { name: "9", value: '9' },
    { name: "10", value: '10' },
    { name: "11", value: '11' },
    { name: "12", value: '12' },
]

export const statusAccess = [{ value: '0', name: 'Недоступен' }, { value: '1', name: 'Доступен' }];
export const degreeOfCapacity = [{ value: '0', name: '' }, { value: 1, name: 'До 40' }, { value: 2, name: '40-100' }, { value: 3, name: 'Свыше 100' }];

export const userMessageTypes = {
    0: 'Все',
    1: 'Преподаватель - учащийся',
    2: 'Преподаватель - родитель',
    3: 'Сотрудник - Сотрудник'
}
export const userRole = [ // Журнал входов //
    // { name: "Все", value: '0' },
    { name: "Учащийся", value: '1' },
    { name: "Учителя", value: '2' },
]

export const recipientTypes = {
    0: 'Учащийся',
    1: 'Родитель',
    2: 'Сотрудник',
    3: 'Роль'
}

export const recipientActionTypes = {
    0: 'STUDENTS',
    1: 'PARENTS',
    2: 'EMPLOYEES',
    3: 'ROLES'
}

// -------------------------------------Кадровый состав-------------------------------------
export const marriageState = [
    { name: 'Никогда нсостоял(не состояла) в браке' },
    { name: 'Состоит в зарегистрированом браке' },
    { name: 'Состоит в  незарегистрированом браке' },
    { name: 'Разведен(разведена)' },
    { name: 'Вдовец (вдова)' },
    { name: 'Разошелся (разошлась)' },
]

export const citizenshipOKIN = [
    { name: 'Гражданин Российской Федерации' },
    { name: 'Гражданин Российской Федерации и иностранного государства (двойное гражданство)' },
    { name: 'Иностранный гражданин' },
    { name: 'Лицо без гражданства' },
    { name: '' }
]

export const MILITARY_RANKS = [
    'Рядовой',
    'Ефрейтор',
    'Матрос',
    'Старший матрос',
    'Младший сержант',
    'Сержант',
    'Старший сержант',
    'Старшина',
    'Старшина 2 статьи',
    'Старшина 1 статьи',
    'Главный старшина',
    'Главный корабельный старшина',
    'Прапорщик',
    'Старший прапорщик',
    'Мичман',
    'Старший мичман',
    'Младший лейтенант',
    'Лейтенант',
    'Старший лейтенант',
    'Капитан',
    'Капитан-лейтенант',
    'Майор',
    'Подполковник',
    'Полковник',
    'Капитан 3 ранга',
    'Капитан 2 ранга',
    'Капитан 1 ранга',
    'Генерал-майор',
    'Генерал-лейтенант',
    'Генерал-полковник',
    'Генерал армии',
    'Контр-адмирал',
    'Вице-адмирал',
    'Адмирал',
    'Адмирал флота',
    'Маршал Российской Федерации'
]

export const STUDY_FORMS = ['очно', 'заочно']
export const STUDY_PERIOD = ['семестр', 'триместр', 'четверть']
export const KLASS_JURNALE = ['новый', 'старый']

export const schoolGrades = [
    { name: '5', value: '5' },
    { name: '4', value: '4' },
    { name: '3', value: '3' },
    { name: '2', value: '2' },
]